class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    if(facetForm){
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
    const sortChange = this.querySelector('form select');
    if(sortChange){
       sortChange.addEventListener('change', this.debouncedOnSubmit.bind(this), true);
     }
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    // console.log('render page');
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (document.body.contains(countContainer)){
      countContainer.classList.add('loading');
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        hideEmptyTagsGroups();
        sortFilterMove();
        insertCustomBanner();
        bannerSize();
        $('.btn').on('mouseenter', function(e) {
          var parentOffset = $(this).offset(),
              relX = e.pageX - parentOffset.left,
              relY = e.pageY - parentOffset.top;
              // console.log(e);
              // console.log(parentOffset);
          $(this).find('ins').css({top:relY, left:relX})
        })
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    hideEmptyTagsGroups();
    sortFilterMove();
    insertCustomBanner();
    bannerSize();
    $('.btn').on('mouseenter', function(e) {
      var parentOffset = $(this).offset(),
          relX = e.pageX - parentOffset.left,
          relY = e.pageY - parentOffset.top;
          // console.log(e);
          // console.log(parentOffset);
      $(this).find('ins').css({top:relY, left:relX})
    })
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (document.body.contains(container)) { 
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
      container.innerHTML = count;
      container.classList.remove('loading');
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }


  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
console.log('currentElement')
      console.log(currentElement)
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }



  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }
  

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];

      sortFilterForms.forEach((form) => {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (button){
    button.addEventListener('click', (event) => {
      this.expandShowMore(event);
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
        nextElementToFocus.querySelector('input').focus()
      }
    });
    }
  }
  expandShowMore(event) {
    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
    const parentWrap = parentDisplay.querySelector('.parent-wrap');
    this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
    parentDisplay.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

///////////// Custom code for our theme ////////////////

// Hide empty tag groups
function hideEmptyTagsGroups(){
  $( "#FacetFiltersForm .js-filter-group" ).each(function() {
    var filterGroupList = $( this ).find('ul'); 
    if (!$.trim( filterGroupList.html() ).length){
      $( this ).hide();
    }else{
      $( this ).show();
    }
  });
}

hideEmptyTagsGroups();

// Mobile filters menu
$( "#filter-btn-mob, .filters-hamburger, .facets-apply_filters" ).on( "click", function() {
    $( ".facets-wrapper").toggleClass("facets-wrapper--open");
    $( "body").toggleClass("body-noscroll");
});


function customSelectTrigger(){
  var $select =  $('#SortBy'),
  numberOfOptions = $select.children('option').length;
      var html = "";
      if(!$select.parent('.sort-select').length){
          $select.addClass('sort-select-hidden');
          $select.wrap('<div class="sort-select"></div>');
          $select.after('<div class="sort-select-styled"></div>');
      }

  var $styledSelect = $select.next('div.sort-select-styled');
  $styledSelect.text($select.children('option:selected').text());

  var sortcheckbox = '<span class="sort-select-options--checkbox"><span aria-hidden="true" class="filter-checkmark"><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.888 2.666 4 7.555 1.778 5.333" stroke="#fff" stroke-width=".889" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></span>';
  var $list = $('<ul />', {
      'class': 'sort-select-options'
  }).insertAfter($styledSelect);
  // console.log(numberOfOptions)
  for (var i = 0; i < numberOfOptions; i++) {
      if($select.children('option').eq(i).val() != ''){
          const listItem = $('<li rel="'+$select.children('option').eq(i).val()+'">'+sortcheckbox+$select.children('option').eq(i).text()+'</li>');
          listItem.appendTo($list);
      }else {
          const listItem = $('<li rel="first">'+sortcheckbox+$select.children('option').eq(i).text()+'</li>');
          listItem.appendTo($list);
      }

  }

  var $listItems = $list.children('li');

  $('.facets-filters__sort-btn').click(function(e) {
      e.stopPropagation();
      $(this).toggleClass('active');
      var sortStyled = $(this).find('.sort-select-styled');
      $('div.sort-select-styled.active').not(sortStyled).each(function() {
          sortStyled.removeClass('active').next('ul.sort-select-options').hide();
      });
      if (sortStyled.hasClass("active")) {
          sortStyled.removeClass('active').next('ul.sort-select-options').hide();
      } else {
          sortStyled.addClass('active').next('ul.sort-select-options').show();
      }
  });

  // set active filter so we can visually show that it is active one
  var selectedOnLoadOption = $('#SortBy option[selected="selected"]').attr("value");
  $('.sort-select-options li[rel="'+selectedOnLoadOption+'"]').addClass("active-sort");
  
  // only way to really update the original select
  var tackleOriginalSelect = new Event('change');

  // behavior on custom select options click
  $listItems.click(function(e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $listItems.removeClass('active-sort');
      $(this).addClass('active-sort');
      $('#sort-mobile .sort-select-options li').removeClass('active-sort');
      $('#sort-mobile .sort-select-options').find('li[data-rel="'+($(this).attr('rel'))+'"]').addClass('active-sort');
      $('#SortBy option').removeAttr("custom-selected");
      $('#SortBy option[value="'+($(this).attr('rel'))+'"]').attr("custom-selected","true");
      $select.val($(this).attr('rel')).attr("selected","selected");
      $list.hide();
      $select.trigger( 'change' );
      // REALLY update original select, like user clicked on it
      const selectEl = document.getElementById('SortBy');
      selectEl.dispatchEvent(new Event('change'));
  });

  //close when clicked outside of the container
  $(document).click(function() {
      $('.facets-filters__sort-btn').removeClass('active');
      $list.hide();
  });
}
customSelectTrigger();

function sortFilterMove(){
  $( "#sort-mobile .sort-select-options li" ).each(function() {
    var sortOption = $( this ).attr( "data-rel" );
    $(this).click(function(e) {
      $( "#sort-mobile .sort-select-options li" ).removeClass('active-sort');
      $(this).addClass('active-sort');
      $('.facets-filters__sort-btn .sort-select-options').find('li[rel="'+sortOption+'"]').trigger( "click" );
    });
  });

}
sortFilterMove();

function insertCustomBanner(){
  if ($('[data-grid-banner]').length){
    var gridCount = $('#product-grid').attr('data-grid-count');
    var gridBanners = $('[data-grid-banner]').html();
    if ( gridCount > 4 ){
      $('#product-grid .grid__item:nth-child(4)').after(gridBanners); 
    }else{
      $('#product-grid .grid__item:last-child').after(gridBanners);
      if ( gridCount == 1 || gridCount == 3  ){
        $('[data-grid-banner-item]').addClass('grid-banner--half');
      }else{
       $('[data-grid-banner-item]').removeClass('grid-banner--half');
      }
    }
  }
}
insertCustomBanner();

function bannerSize(){
  let gridItem = document.querySelector(".grid__card-wrapper");
  let gridItemBanner = document.querySelector(".grid__item--banner");
  let gridItemBannerHalf = document.querySelector(".grid-banner--half");
    if (gridItemBanner && gridItem) {
      let gridItemHeight = gridItem.offsetHeight;
      let gridItemWidth = gridItem.offsetWidth;
      if (window.innerWidth > 1024) {
        gridItemBanner.style.height = `${gridItemHeight}px`;
        gridItemBanner.style.maxWidth = `${gridItemWidth}px`;
      }else{
        gridItemBanner.style.height = '';
        gridItemBanner.style.maxWidth = '';
      }
  }
}

 $(window).on("load scroll resize", function(){
  bannerSize();
 });
